export default {
  data () {
    return {
      position: {
        top: '50%',
        left: '50%'
      }
    };
  },
  computed: {
    style () {
      return {
        position: 'absolute',
        left: this.position.left,
        top: this.position.top
      };
    }
  },
  methods: {
    moveTo (origin) {
      this.position = Object.assign({}, this.position, origin);
    },
    getPosition () {
      // Extract the left and top positions from the container's transform styling.
      return {
        left: parseInt(this.position.left, 10),
        top: parseInt(this.position.top, 10)
      };
    },
    savePosition () {
      const key = getComponentId(this);
      localStorage.setItem(key, JSON.stringify(this.position));
    },
    restorePosition () {
      const key = getComponentId(this);
      const position = localStorage.getItem(key);
      if (position) {
        this.position = JSON.parse(position);
      }
    }
  }
};

const STORAGE_KEY = 'lbs-pi-position-mixin:';

function getComponentId (component) {
  // Vue components are created with deterministic data-v- identifiers. This gives us reasonable confidence we'll be
  // saving the same component.
  const attrs = component.$el.attributes;
  for (let i = 0; i < attrs.length; i++) {
    if (attrs.item(i).name.startsWith('data-v-')) {
      return STORAGE_KEY + attrs.item(i).name;
    }
  }
  // If we can't find one for some reason, use the classlist.
  return STORAGE_KEY + component.$el.className;
}



// WEBPACK FOOTER //
// ./src/uScope/js/components/mixins/positionable-mixin.js